module.exports = __webpack_public_path__ + "static/media/libro14.1df8c1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro14.png
// module id = 362
// module chunks = 0